export function hasUnresolvedToken(text: string | null | undefined): boolean {
  if (typeof text !== 'string') return false;
  if (!text.includes('{')) return false;

  const openIndex = text.indexOf('{');
  return text.includes('}', openIndex + 1);
}

export function sanitizeMetaText(
  text: string | null | undefined
): string | undefined {
  if (typeof text !== 'string') return undefined;

  const trimmed = text.trim();
  if (!trimmed) return undefined;
  if (hasUnresolvedToken(trimmed)) return undefined;

  return trimmed;
}

export function resolveMetaText(
  ...candidates: Array<string | null | undefined>
): string | undefined {
  for (const candidate of candidates) {
    const sanitized = sanitizeMetaText(candidate);
    if (sanitized) return sanitized;
  }

  return undefined;
}
